import type { WorkflowStepPromptsPayload } from '@Application/Organizations/Workflows/Actions/organizationWorkflowsFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * The prompts a document runs with; `is*Personalized` tells whether each one departs from the catalogue default.
 */
class WorkflowPromptsView {
	readonly systemPrompt: string;
	readonly contextPrompt: string;
	readonly isSystemPromptPersonalized: boolean;
	readonly isContextPromptPersonalized: boolean;

	constructor(payload: WorkflowStepPromptsPayload) {
		this.systemPrompt = payload.systemPrompt;
		this.contextPrompt = payload.contextPrompt;
		this.isSystemPromptPersonalized = payload.isSystemPromptPersonalized;
		this.isContextPromptPersonalized = payload.isContextPromptPersonalized;

		Object.freeze(this);
	}
}

export default WorkflowPromptsView;
